/** 活动总结 JSON（activitySummaryJson）中扩展字段：是否开启抽奖 */

export function parseLotteryEnabledFromActivitySummaryJson(raw: string | null | undefined): boolean {
  if (!raw?.trim()) return false
  try {
    const o = JSON.parse(raw) as { lotteryEnabled?: unknown }
    return o?.lotteryEnabled === true
  } catch {
    return false
  }
}

export function mergeLotteryIntoActivitySummaryJson(
  existingJson: string | null | undefined,
  lotteryEnabled: boolean,
): string | null {
  let obj: Record<string, unknown> = {}
  if (existingJson?.trim()) {
    try {
      const p = JSON.parse(existingJson)
      if (p && typeof p === 'object' && !Array.isArray(p)) obj = { ...(p as Record<string, unknown>) }
    } catch {
      obj = {}
    }
  }
  obj.lotteryEnabled = lotteryEnabled
  return JSON.stringify(obj)
}
